import React, { useState, useEffect } from "react";
import { Form, Radio } from "antd";
import Typing from "../Typing/Typing";
import * as Utils from "../../services/utils";
import CmpsAnimation from "../CmpsAnimation/CmpsAnimation";
import Timestamp from "../../components/Timestamp/Timestamp";
import CmpsMsgStatus from "../CmpsMsgStatus/CmpsMsgStatus";

function CmpsConsentFirst({ onComplete, onScroll, form, onShowInput }) {
    const [typing, setTyping] = useState(true);
    const [msg, setMsg] = useState(false);
    const [msgChoose, setMsgChoose] = useState(true);

    let list = [
        { label: "Acconsento", value: true },
        { label: "Non acconsento", value: false },
    ];

    const onChange = (e) => {
        setMsg(form.getFieldValue("primo_consenso").label);
        setMsgChoose(false);
        onComplete("step13");
    };

    useEffect(() => {
        Utils.eventsDataLayer("customPageview", "/chatbot-fissa-appuntamento/privacy-step-1");
        onShowInput(false);
        const timer = setTimeout(() => {
            setTyping(false);
            onScroll();
        }, 2200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section id="cmps-consent1">
            {typing && <Typing wait={1200} />}
            {!typing && (
                <div className="messages messages--receiver">
                    <div className="message">
                        <CmpsAnimation wait={300}>
                            <span className="bubble">
                                Manca solo un’ultima cosa:
                                <br /> abbiamo bisogno del tuo
                                <br />
                                consenso al trattamento dei tuoi
                                <br /> dati per fissare l’appuntamento
                                <br />
                                e valutare l’eventuale richiesta di
                                <br /> credito.
                            </span>
                        </CmpsAnimation>
                        <CmpsAnimation wait={600}>
                            <span className="bubble">
                                <b>
                                    Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di
                                    protezione dei dati personali{" "}
                                    <a href="/share/pdfsni/PRIVACY_FA.PDF" target="_blank">
                                        qui scaricabile
                                    </a>
                                    .
                                </b>
                                <br />
                                <br />
                                Il Sottoscritto preso atto dell'Informative rese da Compass{" "}
                                <a href="/share/pdfs/CO087FB_ONLINE.pdf" target="_blank">
                                    ai sensi degli art. 13 e 14 del Regolamento UE 2016/679
                                </a>{" "}
                                e della normativa nazionale ed europea vigente in materia di protezione dei dati personali e del Codice di condotta per i sistemi informativi in tema di credito al
                                consumo, affidabilità e puntualità dei pagamenti, acconsente/non acconsente espressamente al trattamento dei dati per:
                            </span>
                        </CmpsAnimation>
                        <CmpsAnimation wait={900}>
                            <span className="bubble">
                                {/* Dichiari di aver scaricato e letto<br /> le informative e che i tuoi dati<br /> personali, ivi inclusi i dati 
                relativi<br /> all'andamento dei rapporti e i<br /> dati relativi all'esposizione<br /> anche nei confronti delle società<br />
                del Gruppo Mediobanca, siano<br /> trattati da Compass Banca S.p.A<br /> e da Società appartenenti al<br /> Gruppo Mediobanca<br />
                (direttamente o per il tramite di<br /> soggetti terzi), per la finalità<br /> indicata alla lettera b) in<br /> relazione ai 
                prodotti e servizi<br /> propri e di terzi. */}
                                <b>
                                    Consenso al trattamento dei dati per ricerche di mercato, attività commerciali e promozionali di prodotti offerti da Compass e delle società controllate e dalle
                                    società del gruppo bancario di appartenenza (lettera b).
                                </b>
                                <br />
                                <br />
                                Preso atto dell’Informativa resa da Compass Banca S.p.A. ai sensi degli artt. 13 e 14 del Regolamento e della normativa nazionale vigente in materia di protezione dei
                                dati personali e del Codice di condotta per i sistemi informativi gestiti da soggetti privati in tema di crediti al consumo, affidabilità e puntualità nei pagamenti,
                                che i tuoi dati personali, ivi inclusi i dati relativi all’andamento dei rapporti e i dati relativi all’esposizione, anche nei confronti delle Società controllate e
                                dalle società del gruppo bancario di appartenenza, siano trattati da Compass e da società controllate e dalle società appartenenti al gruppo bancario di appartenenza
                                (direttamente o per il tramite di soggetti terzi), per la finalità indicata alla lettera b) in relazione a prodotti e servizi propri e di terzi.
                            </span>
                        </CmpsAnimation>
                        <CmpsAnimation wait={1200} last={!msgChoose}>
                            <span className="bubble">
                                {/* Tale consenso comprende<br /> altresì il consenso al<br /> trattamento dei propri dati<br /> personali mediante l'utilizzo di<br /> strumenti, anche informatici, 
                per<br /> verificare la coerenza dei<br /> prodotti offerti, in adempimento<br /> alle disposizioni di vigilanza. */}
                                Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l’utilizzo di strumenti, anche informatici, per verificare la coerenza dei
                                prodotti offerti, in adempimento alle disposizioni di vigilanza.
                            </span>
                        </CmpsAnimation>
                        {msgChoose && (
                            <CmpsAnimation wait={1500} last={true}>
                                <span className="bubble">Seleziona la tua scelta</span>
                            </CmpsAnimation>
                        )}
                        <CmpsAnimation wait={1800}>
                            {!msg && (
                                <Form.Item className={`cmps_radio_button cmps_radio_button__consent`} name="primo_consenso">
                                    <Radio.Group onChange={onChange}>
                                        {list.map((item, index) => (
                                            <Radio.Button key={index} value={item}>
                                                {item.label}
                                            </Radio.Button>
                                        ))}
                                    </Radio.Group>
                                </Form.Item>
                            )}
                            <div className="info">
                                <span className="time">
                                    <Timestamp />
                                </span>
                            </div>
                        </CmpsAnimation>
                    </div>
                </div>
            )}
            {msg && (
                <div className="messages messages--sender">
                    <CmpsAnimation wait={300}>
                        <div className="message">
                            <span className="bubble">{msg}</span>
                        </div>
                        <div className="info">
                            <span className="time">
                                <Timestamp />
                            </span>
                            <CmpsMsgStatus />
                        </div>
                    </CmpsAnimation>
                </div>
            )}
        </section>
    );
}

export default CmpsConsentFirst;
